const Colors = {
  BORDER_FIELDS: '#B9CBF0',
  // Match buttons & links to the left sidebar color (admin portal only).
  PRIMARY: '#214796',
  BLUE: '#214796',
  // Primary buttons (Search, Download, Export to Excel, etc.) use these keys.
  BRAND_PRIMARY_ACTION: '#214796',
  BG_PRIMARY_BUTTON_HOVER: '#1F71A2',
  BG_PRIMARY_BUTTON_CLICKED: '#16305C',
}

export const customTheme = {
  colors: Colors,
}
